// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  rowId: __t.u64().primaryKey().name("row_id"),
  playerId: __t.string().name("player_id"),
  ruleset: __t.string(),
  eventType: __t.string().name("event_type"),
  territoryId: __t.option(__t.string()).name("territory_id"),
  challengeId: __t.option(__t.string()).name("challenge_id"),
  matchId: __t.option(__t.string()).name("match_id"),
  message: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
});
